import type { AppState } from '@store/types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { NestClient } from '@/nest'

// Opening the report is what puts out the blue dot on its dashboard card, for
// this person only. Keyed on the crawl being shown, so a scheduled crawl that
// lands while the report is open is marked seen too. A visitor who is not
// signed in has no card and no dot, and is never asked about.
export const useMarkReportSeen = (
  uuid: string | undefined,
  currentAt: string | null | undefined
) => {
  const userId = useSelector<AppState, string | null>(({ auth }) => auth.id)

  useEffect(() => {
    if (!uuid || !userId || !currentAt) {
      return
    }

    // The dot is a nicety: a failed mark leaves it on until the next visit,
    // which is not worth telling anyone about.
    NestClient.sitemapReport.seen(uuid).catch(() => undefined)
  }, [uuid, userId, currentAt])
}
